import React, { useEffect, useState } from 'react';
import { getEmailStats } from '../../services/EmailService';

function EmailsStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchStats() {
      setLoading(true);
      setError(null);
      try {
        const data = await getEmailStats();
        setStats(data);
      } catch (err) {
        setError('Failed to load stats');
      }
      setLoading(false);
    }
    fetchStats();
  }, []);

  if (loading) return <div className="mb-4">Loading stats...</div>;
  if (error) return <div className="alert alert-danger mb-4">{error}</div>;
  if (!stats) return null;

  return (
    <div className="row g-3 mb-4">
      <div className="col-12 col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-secondary mb-2"><i className="bi bi-envelope"></i> PROCESSED EMAILS</div>
            <div className="display-5 fw-bold text-dark">{stats.totalProcessedEmailsCount}</div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-secondary mb-2"><i className="bi bi-envelope"></i> DELIVERED EMAILS</div>
            <div className="display-5 fw-bold text-dark">{stats.totalDeliveredEmailsCount}</div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-secondary mb-2"><i className="bi bi-envelope"></i> BOUNCED & BLOCKED</div>
            <div className="display-5 fw-bold text-dark">{stats.totalBouncedAndBlockedEmails}</div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-secondary mb-2"><i className="bi bi-eye"></i> UNIQUE OPENS</div>
            <div className="display-5 fw-bold text-dark">{stats.totalUniqueOpensEmailsCount}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailsStats; 